import { Box, CircularProgress, Typography } from "@mui/material";
import { Fragment } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import useFunctions from "../ts/useFunctions";
import { ProductDetailsRecommendationsWrapper } from "./index.styled";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import SliderCard from "components/pages/home-page/home-featured-products/slider-card";

export default function ProductDetailsRecommendations() {
  const { recommendations } = useFunctions();
  const { loading, data } = recommendations;
  // console.log(data);
  // console.log(data.length === 0);

  return (
    <ProductDetailsRecommendationsWrapper>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection={{ xs: "column", md: "row" }}
      >
        <Typography
          className="main-title"
          color="#8A8A8A"
          fontWeight={500}
          fontSize={{
            xs: "28px",
            md: "32px",
          }}
        >
          Similar Products
        </Typography>
      </Box>
      {loading ? (
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          navigation
          breakpoints={{
            450: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 50,
            },
          }}
          modules={[Navigation]}
          className="custom-product-swiper"
        >
          {[1, 2, 3, 4].map((item) => (
            <SwiperSlide key={item}>
              <SliderCard />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : data.length === 0 ? (
        <Box textAlign="center">
          <Typography variant="h4" color="error">
            No similar products
          </Typography>
        </Box>
      ) : (
        <Fragment>
          <Swiper
            slidesPerView={1}
            spaceBetween={10}
            navigation
            breakpoints={{
              450: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 50,
              },
            }}
            modules={[Navigation]}
            className="custom-product-swiper"
          >
            {data.map((item, index) => (
              <SwiperSlide key={index}>
                <SliderCard data={item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </Fragment>
      )}
    </ProductDetailsRecommendationsWrapper>
  );
}
